<template>
  <com-page>
    <com-search
      :columns="searchColumns"
      @search="handleSearch"
      :default_values="defaultValues"
    ></com-search>
    <com-card>
      <div class="flex items-center justify-between">
        <el-tabs v-model="activeName" @tab-click="handleClick" class="mb-6px">
          <el-tab-pane label="未退款" name="1"></el-tab-pane>
          <el-tab-pane label="已退款" name="2"></el-tab-pane>
          <el-tab-pane label="未支付" name="0"></el-tab-pane>
        </el-tabs>

        <el-button type="primary" @click="handleExport">导出</el-button>
      </div>
      <com-table ref="table" :columns="columns" :api="api" :defaultParams="defaultValues">
        <template #registerTime="row">
          {{ row.data.registerTime || row.data.createTime | formatDate }}
        </template>
        <template #overdueTime="row" v-if="defaultValues.status !== 0">
          {{ row.data.overdueTime || row.data.createTime | formatDate }}
        </template>
        <template #status="{ data }">
          {{ orderStatus[data.status] }}
        </template>
        <template #operation="{ data }">
          <el-button v-if="data.status === 1" type="text" size="small" @click="handleRefund(data)"
            >退款</el-button
          >
        </template>
        <template #minute="{ data }">
          {{ (data.monthCardPlanBean && data.monthCardPlanBean.minPower) || 0 }}W-{{
            (data.monthCardPlanBean && data.monthCardPlanBean.power) || 0
          }}W
        </template>
        <template #price="{ data }">
          {{ (data.monthCardPlanBean && data.monthCardPlanBean.money) || 0 }}元
        </template>
      </com-table>
    </com-card>
    <com-checked-pwd ref="checkedPwd" @confirm="handleConfirm" />
  </com-page>
</template>

<script>
import { exportExcel } from '@/utils/index'
import { formatDate } from '@/filters'
import { history, refund } from '@/api/monthly_card'

export default {
  data() {
    return {
      api: history,
      searchColumns: [
        {
          label: '订单号',
          type: 'input',
          prop: 'number'
        },
        {
          label: '月卡名称',
          type: 'input',
          prop: 'name'
        },
        {
          label: '用户Id',
          type: 'input',
          prop: 'userNumber'
        },
        {
          label: '手机号',
          type: 'input',
          prop: 'phone'
        },
        {
          label: '下单时间',
          type: 'date',
          prop: 'date'
        }
      ],
      columns: [
        {
          label: '订单号',
          prop: 'number',
          auto: true
        },
        {
          label: '月卡名称',
          prop: 'name'
        },
        {
          label: '用户ID',
          prop: 'userNumber',
          auto: true
        },
        {
          label: '手机号',
          prop: 'phone'
        },
        {
          label: '月卡套餐',
          prop: 'minute',
          type: 'slot',
          slotName: 'minute'
        },
        {
          label: '订单金额',
          prop: 'price',
          type: 'slot',
          slotName: 'price'
        },
        {
          label: '开通时间',
          prop: 'registerTime',
          type: 'slot',
          slotName: 'registerTime'
        },
        {
          label: '有限期至',
          prop: 'overdueTime',
          type: 'slot',
          slotName: 'overdueTime'
        },
        {
          label: '退款状态',
          prop: ' status',
          type: 'slot',
          slotName: 'status'
        },
        {
          label: '操作',
          prop: ' operation',
          type: 'slot',
          slotName: 'operation'
        }
      ],
      defaultValues: {
        status: 1
      },
      activeName: '1',
      selectOrder: {},
      exportQuery: {},
      orderStatus: {
        0: '未支付',
        1: '未退款',
        2: '已退款'
      }
    }
  },
  methods: {
    // 切换状态
    handleClick() {
      this.defaultValues.status = +this.activeName
      setTimeout(() => {
        this.$refs.table.init()
      }, 50)
      console.log('object :>> ', this.defaultValues)
    },
    // 搜索
    handleSearch(opt) {
      if (opt.beginTime) {
        opt.startTime = opt.beginTime
      }
      delete opt.beginTime
      this.exportQuery = opt
      this.$refs.table.search(opt)
      console.log('opt :>> ', opt)
    },
    // 退款
    handleRefund(e) {
      console.log('e :>> ', e)
      this.selectOrder = e
      this.$confirm('是否确认退款?该操作不可逆', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$refs.checkedPwd.open()
        })
        .catch(() => {})
    },
    async handleConfirm(val) {
      const params = {
        code: this.selectOrder.code,
        auditPassword: val
      }
      const res = await refund(params)
      if (res.status === 200) {
        this.$message.success(res.desc)
        setTimeout(() => {
          this.$refs.table.init()
        }, 50)
      }
    },
    handleExport() {
      try {
        this.$message.info('请稍等,正在导出...')
        const query = {
          ...this.exportQuery,
          status: this.activeName,
          pageIndex: 1,
          pageSize: 10000
        }
        history(query).then((res) => {
          const { records } = res.data
          // eslint-disable-next-line prefer-const
          let newArr = []
          records.forEach((item) => {
            const params = {
              订单号: item.number,
              月卡名称: item.name,
              用户ID: item.userNumber,
              手机号: item.phone,
              月卡套餐: `${item.monthCardPlanBean ? item.monthCardPlanBean.minPower : '0'}W-${
                item.monthCardPlanBean ? item.monthCardPlanBean.power : '0'
              }W`,
              订单金额: `${item.monthCardPlanBean ? item.monthCardPlanBean.money : '0'}元`,
              开通时间: formatDate(item.registerTime),
              结束时间: formatDate(item.overdueTime),
              退款状态: item.status === 1 ? '未退款' : '已退款'
            }
            newArr.push(params)
          })
          exportExcel(newArr, '开通记录')
        })
      } catch (err) {
        console.log('err :>> ', err)
      }
    }
  },
  created() {
    const { name } = this.$route.params
    if (name) {
      this.defaultValues = { ...this.defaultValues, name }
    }
  }
}
</script>

<style lang="scss" scoped></style>
